import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import img1 from '../../assets/c-logo/10.png'
import img2 from '../../assets/c-logo/11.png'
import img3 from '../../assets/c-logo/12.png'
import img4 from '../../assets/c-logo/13.png'
import img5 from '../../assets/c-logo/14.png'
import img6 from '../../assets/c-logo/15.png'
import img7 from '../../assets/c-logo/16.png'
import img8 from '../../assets/c-logo/17.png'
import img9 from '../../assets/c-logo/18.png'
import img10 from '../../assets/c-logo/19.png'
import img11 from '../../assets/c-logo/20.png'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const Acadereview = () => {
  return (
    <section className='clientsays'>
        <div class="row pb-5">
                
                <div class="col-lg-12">
                   
                     <Carousel responsive={responsive} arrows={false} showDots={true} infinite={true} autoPlay={true}
                            >
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img1} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">Our students found the webinar session highly useful and career-oriented. The mentor shared valuable insights that motivated the learners. Takshila team handled everything very professionally and efficiently. We would like to partner with you to organize more training sessions ahead.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>P.E.S College of Engineering</h5>
                                        <h6 className='author-course'>Vinay – Placement Officer</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img2} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The webinar went very well and was beneficial for our final-year students. The mentor’s teaching style was interactive and well-organized. We are happy with your overall communication and scheduling. Please plan more such sessions covering advanced topics too.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>BV Raju Institute of Technology</h5>
                                        <h6 className='author-course'>Dr. K. Lakshmi Prasad – Principal</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img3} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The session was insightful and gave our students a clear understanding of VLSI. Your mentor explained the concepts with practical clarity. The coordination from your end was professional and supportive. We recommend adding some career guidance points next time.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Gokaraju Rangaraju Institute of Engineering &Technology</h5>
                                        <h6 className='author-course'>Dr.Dr.Usha Kumari – HOD ECE</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img4} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The webinar content was well-prepared and relevant to our students. The mentor made the complex topics very simple and interesting. Your team’s coordination and communication were impressive. Please include a short quiz or feedback form next time.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>RV Institute of Technology and Management</h5>
                                        <h6 className='author-course'>Dr Malini pathil – ECE HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img5} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The session was informative and aligned well with student interests. Your mentor delivered the topic with confidence and clarity. We are pleased with your overall coordination and responsiveness. We are keen to collaborate for advanced training opportunities for our students.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Jawaharlal Nehru Technological University, Hyderabad</h5>
                                        <h6 className='author-course'>Dr. Rajani - ECE HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img6} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The session was very informative and aligned with our curriculum. Your mentor’s presentation style was engaging and easy to understand. We appreciate your team’s efforts in conducting it smoothly. Adding some real-time project examples would enhance future sessions.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Bangalore institute of Technology</h5>
                                        <h6 className='author-course'>Mukthi - Asst. Prof. ECE</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img7} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">It was a wonderful learning experience for our students. The mentor kept the session lively and explained each point clearly. Your team was well-organized and maintained good coordination. Please consider extending the duration for more topic coverage.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>The Oxford College of Engineering</h5>
                                        <h6 className='author-course'>Dr. Manju Devi - ECE HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img8} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The online session was well-structured and beneficial for our students. Your mentor shared valuable insights with great clarity and patience. We truly appreciate your smooth coordination and professionalism. It would be nice to cover more case studies in upcoming sessions.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Dayananda Sagar College of Engineering</h5>
                                        <h6 className='author-course'>Dr. T. C. Manjunath - ECE HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img9} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">It was a very good and informative webinar for our students. The mentor interacted well and cleared all the doubts patiently. We appreciate your proper communication and smooth process.
Would be great to have regular sessions like this in future.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>NBKR Institute Of Science and Technology</h5>
                                        <h6 className='author-course'>Dr. K. Nagireddy – ECE HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img10} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The webinar was excellent and very useful for our ECE students. The mentor’s explanation was simple, clear, and easy to follow. Your process and communication were well-handled from start to end. We suggest adding a short demo session next time for better learning.
</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Anil Neerukonda Institute of Technology & Sciences</h5>
                                        <h6 className='author-course'>Dr.V.Rajya Lakshmi – ECE HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div class="p-lg-4">
                            <div class="carousel-box-2 bg-10 p-5 radius-1">
                                <div class="carousel-box-icon mb-4">
                                <img src={img11} alt=''/>
                                </div>
                                <div class="carousel-box-bottom">
                                    <p class="carousel-box-desc mb-3">The session gave our students a clear understanding of chip design flow. Your mentor covered all technical areas in a simple and detailed manner. The coordination process was seamless from your side. We would be happy to associate again for upcoming VLSI training programs.</p>
                                </div>
                                <div class="carousel-box-author d-flex align-items-center">
                                    
                                    <div className='author-detail'>
                                        <h5 className='author-name'>Bharati Vidyapeeth College of engineering</h5>
                                        <h6 className='author-course'>Shruti Oza Rahurkar – E&TC HOD</h6>
                                    </div>
                                </div>
                            </div>
                            </div>
                            
                            
                            </Carousel>

                </div>
            </div>
    </section>
  )
}

export default Acadereview